import React, { useEffect, useRef } from 'react';
import { XIcon } from 'lucide-react';
interface PolicyModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: React.ReactNode;
}
export function PolicyModal({
  isOpen,
  onClose,
  title,
  content
}: PolicyModalProps) {
  const modalRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    const handleClickOutside = (e: MouseEvent) => {
      if (modalRef.current && !modalRef.current.contains(e.target as Node)) {
        onClose();
      }
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.addEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.removeEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = 'auto';
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" data-id="element-309">
      <div ref={modalRef} className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] flex flex-col" data-id="element-310">
        <div className="flex justify-between items-center border-b border-stone-200 px-6 py-4" data-id="element-311">
          <h2 className="text-xl font-bold text-stone-800" data-id="element-312">{title}</h2>
          <button onClick={onClose} className="text-stone-500 hover:text-stone-700 transition-colors" aria-label="Close" data-id="element-313">
            <XIcon className="w-5 h-5" data-id="element-314" />
          </button>
        </div>
        <div className="p-6 overflow-y-auto" data-id="element-315">{content}</div>
        <div className="border-t border-stone-200 px-6 py-4 flex justify-end" data-id="element-316">
          <button onClick={onClose} className="bg-stone-200 hover:bg-stone-300 text-stone-800 px-4 py-2 rounded-md transition-colors" data-id="element-317">
            Close
          </button>
        </div>
      </div>
    </div>;
}